import * as React from "react";
import Background from "src/components/BackgroundComponent";
import FooterContainer from "src/containers/FooterContainer";
import NavigationContainer from "src/containers/NavigationContainer";

import HeaderContainer from "src/containers/HeaderContainer";
import TextContainer from "src/containers/TextContainer";
import { INavTypeObj, IScrollyComponent } from "src/ScrollyInterface";
import Spinner from "src/UI/Spinner";
import "./ScrollyComponent.scss";

const scrollyComponent = (props: IScrollyComponent) => {
  const navType: INavTypeObj = {
    desktop: "desktop",
    mobile: "mobile"
  };

  const {
    content,
    elemNumber,
    links,
    muted,
    navImages,
    mediaLoaded,
    onMediaLoaded,
    onVideoLoaded,
    scrollDirection,
    showSideDrawer,
    videoLoaded
  } = props;

  const contentStyle = showSideDrawer
    ? { backgroundColor: "rgba(0, 0, 0, 0.85)" }
    : {};

  return (
    <div className="Scrolly">
      <div className="Scrolly-content" style={contentStyle}>
        <HeaderContainer
          links={links}
          navImages={navImages}
          navType={navType}
        />
        <div className="Scrolly-container">
          <div className="Scrolly-subcontainer">
            <div className="Scrolly-text-container">
              <TextContainer />
              <NavigationContainer
                navImages={navImages}
                navType={navType.desktop}
              />
            </div>
          </div>
        </div>
        <FooterContainer elemNumber={elemNumber} />
      </div>
      <Background
        content={content}
        muted={muted}
        onMediaLoaded={onMediaLoaded}
        onVideoLoaded={onVideoLoaded}
        scrollDirection={scrollDirection}
        videoLoaded={videoLoaded}
      />
      <Spinner hide={mediaLoaded} />
    </div>
  );
};

export default scrollyComponent;



// WEBPACK FOOTER //
// ./src/components/ScrollyComponent.tsx